// extracted by mini-css-extract-plugin
module.exports = {"historyWrapper":"HistoryList_historyWrapper__Ce0th","container":"HistoryList_container__1giQ4","title":"HistoryList_title__29GiP","item":"HistoryList_item__cA8w6"};